export default __webpack_public_path__ + "static/media/cog-circle-tc.a2bf43d8.svg";